import { Action, getModule, Module } from 'vuex-module-decorators';

import store from '@/store';
import EntityBaseModule from '@/store/entity';

import EntityModel from './entityModel';
import { getById, updateEntity, addNewEntity, removeEntity } from '@/api/crud';

import { Symptoms } from '@/models/symptoms';

export const MODULE_NAME = Symptoms.moduleEntityName;

@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class SymptomEntityModule extends EntityBaseModule {
    model: any;

    constructor(module: SymptomEntityModule) {
        super(module);

        const entityModel = new EntityModel();
        this.model = entityModel.model;
    }

    @Action({ rawError: true })
    async getById(id: string) {
        try {
            const result = await getById(Symptoms.apiPrefix, id);

            return result.symptom;
        } catch (clientError) {
            const error = clientError.response.data;

            throw new Error(error.message);
        }
    }

    @Action({ rawError: true })
    async update(params: { id: string; data: Record<string, any> }) {
        return await updateEntity(Symptoms.apiPrefix, params.id, params.data);
    }

    @Action({ rawError: true })
    async create(data: Record<string, any>) {
        return await addNewEntity(Symptoms.apiPrefix, data);
    }

    @Action({ rawError: true })
    async remove(id: string) {
        return await removeEntity(Symptoms.apiPrefix, id);
    }
}

export default getModule(SymptomEntityModule);
